$(document).on('click','.js-add-to-favourite', function(){
    toggleProductFavourite(1, 'add_product_to_favourite', $(this));
})
$(document).on('click','.js-remove-from-favourite', function(){
    toggleProductFavourite(0, 'remove_product_from_favourite', $(this));
})

function toggleProductFavourite(add, action, wrapper){
    if(!wrapper.hasClass('disabled')) {
        wrapper.addClass('disabled');
        $('svg', wrapper).hide().after('<img class="loader mr-2" style="height:25px; width:25px;" src="' + LOADER + '" alt="ajax loader">');
        let product_id = wrapper.attr('data-product-id');

        let data = {
            action: action,
            product_id: product_id
        };

        jQuery.post(BASE_URL + '/wp-admin/admin-ajax.php', data, function (response) {
            wrapper.parent('.favourite_wrapper').toggleClass('added');
            $('.loader', wrapper).remove();
            $('svg', wrapper).fadeIn();

            let fav_counts = $('.js-favourite-count');
            let fav_count_old_val = fav_counts.first().text();
            let fav_count_new_val = parseInt(fav_count_old_val);

            if (add) {
                notif('success', response);
                fav_count_new_val++;
            } else {
                notif('warning', response);
                fav_count_new_val--;
            }
            fav_counts.text(fav_count_new_val);
            wrapper.removeClass('disabled');
        });
    }
}
